import { Modal } from "components/ui/modals/Modal/Modal"
import { H3 } from "components/ui/typography/titles/Titles"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { ButtonWarning } from "components/ui/buttons/ButtonWarning/ButtonWarning"
import { Skeleton } from "components/ui/skeleton/Skeleton"
import style from "./DeleteModal.module.scss"

const { title, warningText, buttonsBlock, deleteButton } = style

type Props = {
	text: string
	title: string
	isPending: boolean
	isModalOpen: boolean
	setModalClose: () => void
	deleteHandle: () => void
}

export const DeleteModal = (props: Props) => {
	return (
		<Modal isModalOpen={props.isModalOpen} setModalClose={props.setModalClose} width={460}>
			<div data-testid="delete-modal">
				{props.isPending ? (
					<div data-testid="skeleton">
						<Skeleton />
					</div>
				) : (
					<>
						<H3 className={title}>{props.text}</H3>
						<p className={warningText}>{props.title}</p>
						<div className={buttonsBlock}>
							<ButtonPrimary onClick={props.setModalClose}>Cancel</ButtonPrimary>
							<ButtonWarning onClick={props.deleteHandle} className={deleteButton}>
								Delete
							</ButtonWarning>
						</div>
					</>
				)}
			</div>
		</Modal>
	)
}
